import { StackerPulpit } from "@/pages/stacker-pulpit";

export const routeStackerProduction = "/stacker-production";
export const millStackerProductionPermission =
	"ui.navbar.mill.stacker.production";

export const stackerPulpitRoutes = [
	{
		path: `${routeStackerProduction}`,
		element: <StackerPulpit />,
		permission: millStackerProductionPermission,
	},
	{
		path: `${routeStackerProduction}/:shiftId`,
		element: <StackerPulpit />,
		permission: millStackerProductionPermission,
	},
];
